module.exports = __webpack_public_path__ + "img/question@3x.526184dd.png";